import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static values = {
    trackMatomoGoalId: { type: Number, default: -1 },
  };

  connect() {
    this.form = this.element.querySelector('form');
    this.form.addEventListener('ajax:success', this.handleSuccess.bind(this));
    this.form.addEventListener('ajax:error', this.reloadWindow.bind(this));
  }

  handleSuccess() {
    if (this.hasTrackMatomoGoalIdValue && this.trackMatomoGoalIdValue > 0) {
      window.top._paq.push(['trackGoal', this.trackMatomoGoalIdValue]);
    }

    this.reloadWindow();
  }

  reloadWindow() {
    window.location.reload();
  }
}
